// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/red-trash.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-container {
  display: flex;
  justify-content: flex-start;
  height: 350px;
  overflow: auto;
  flex-direction: column;
  align-content: flex-start;
  align-items: stretch;
  padding-right: 30px;
}

.team-container .team-card:nth-child(1) {
  border-top: none;
}

.team-card {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 14px;
  padding-bottom: 14px;
  border-top: solid 1px #E7ECEE;
}
.team-card:first-child {
  margin-top: 20px;
}
.team-card img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.team-image {
  width: 90px;
}

.team-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.team-remove {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.team-row {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 290px;
}

.team-content h4 {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.team-content .form-group {
  margin-bottom: 0px;
}

.team-content .form-group label {
  color: #141718;
}

.team-name {
  display: flex;
  flex: 1 1;
}

.team-name .user-name {
  font-weight: 500;
  letter-spacing: -0.5px;
}

.team-login {
  font-weight: 100;
  font-size: 12px;
  flex: 1 1;
  color: #B6B8B9;
  font-weight: 500;
}

.team-admin {
  margin-left: 10px;
  background-color: #ff97e8;
  color: #141718;
}

.manage-user-btn {
  font-size: 14px;
  padding: 12px 24px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Team/team.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,6DAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AADF;;AAIA;EACE,gBAAA;EACA,qBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;AADF;;AAIA;EACE,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;AADF","sourcesContent":[".team-container {\n  display: flex;\n  justify-content: flex-start;\n  height: 350px;\n  overflow: auto;\n  flex-direction: column;\n  align-content: flex-start;\n  align-items: stretch;\n  padding-right: 30px;\n}\n\n.team-container .team-card:nth-child(1) {\n  border-top: none;\n}\n\n.team-card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  border-top: solid 1px #E7ECEE;\n\n  &:first-child {\n    margin-top: 20px;\n  }\n\n  img {\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n  }\n}\n\n.team-image {\n  width: 90px;\n}\n\n.team-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.team-remove {\n  background: url(\"../../Assets/Images/red-trash.svg\") no-repeat;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.team-row {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 290px;\n}\n\n.team-content h4 {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.team-content .form-group {\n  margin-bottom: 0px;\n}\n\n.team-content .form-group label {\n  color: #141718;\n}\n\n.team-name {\n  display: flex;\n  flex: 1;\n}\n\n.team-name .user-name {\n  font-weight: 500;\n  letter-spacing: -0.5px;\n}\n\n.team-login {\n  font-weight: 100;\n  font-size: 12px;\n  flex: 1;\n  color: #B6B8B9;\n  font-weight: 500;\n}\n\n.team-admin {\n  margin-left: 10px;\n  background-color: #ff97e8;\n  color: #141718;\n}\n\n.manage-user-btn {\n  font-size: 14px;\n  padding: 12px 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
